import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { SupportComponent } from "./auth/support/support.component";

const routes: Routes = [
  {
    path: "support",
    component: SupportComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
